// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3e95H","description":"PatientConsentPreview_description__1qJBC"};